module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-qoro-corian-slope.07fec797.jpg";